<div class="container mx-auto device-content">
    <div class="hero-text" fxLayout="row" fxFlexAlign="center">
        <h1 style="font-weight:800;">{{'CONTAINER_LOCATION_DETERMINATION_FORM'|translate}}</h1>
    </div>
    <div fxLayout="row wrap" fxFlexAlign="center">
        <div fxFlex="100">
            <mat-form-field fxFlex="100" appearance="outline">
                <mat-label>{{'PLEASE_CHOOSE_THE_CONTAINER'|translate}}</mat-label>
                <mat-select [(ngModel)]="selectedContainer" placeholder="{{'PLEASE_CHOOSE_THE_CONTAINER'|translate}}" name="container">
                    <mat-option *ngFor="let container of containerList" [value]="container">
                        {{container.c_Id?(container.c_Id+" - "):""}}{{container.streetDesc || '' }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <button style="margin-top: 10px;" mat-raised-button (click)="save()">
            <span>{{'CREATE'|translate}}</span>
        </button>
    </div>

</div>